export default {
  playerDivision: (rank, numberOfRankings) => {
    let division
    let percentile = rank / numberOfRankings

    if (rank <= 200) {
      division = 'Grandmaster'
    } else if (percentile <= 0.02) {
      division = 'Master'
    } else if (percentile <= 0.20) {
      division = 'Diamond'
    } else if (percentile <= 0.4) {
      division = 'Platinum'
    } else if (percentile <= 0.6) {
      division = 'Gold'
    } else if (percentile <= 0.8) {
      division = 'Silver'
    } else {
      division = 'Bronze'
    }

    return division
  },
  playerPercent: (rank, numberOfRankings) => {
    let percentile = parseInt((rank / numberOfRankings) * 100, 10)

    return percentile
  },
  playerPercentile: (rank, numberOfRankings) => {
    let percentile = parseInt((1 - (rank / numberOfRankings)) * 100, 10)
    // const mod10 = percentile % 10
    // const mod100 = percentile % 100
    // let suffix

    // if (mod10 === 1 && mod100 !== 11) {
    //   suffix = 'st'
    // } else if (mod10 === 2 && mod100 !== 12) {
    //   suffix = 'nd'
    // } else if (mod10 === 3 && mod100 !== 13) {
    //   suffix = 'rd'
    // } else {
    //   suffix = 'th'
    // }

    // return percentile + suffix
    return percentile
  },
  rankBadgePath: (miniGameProfile, powerRankingCount, powerRankings, rank) => {
    let path = '/images/rankBadges/'
    const percentile = rank / powerRankingCount

    if (percentile <= 0.6 && miniGameProfile.highScore > 0) {
      path += 'gold-star.png'
    } else if (percentile <= 0.8 && miniGameProfile.highScore > 0) {
      path += 'silver-star.png'
    } else if (miniGameProfile.highScore > 0) {
      path += 'bronze-star.png'
    } else {
      path += 'question-mark.png'
    }

    return path
  },
}



// WEBPACK FOOTER //
// ./src/app/filters/rankings.js